/** @jsx h */
import { h, Component } from 'preact'
import CloseButton from '../CloseButton'

export default class JourneyDrawer extends Component {
  render ({ open, children, close }) {
    return (
      <div class={`JourneyDrawer ${open ? 'JourneyDrawer--open' : ''}`}>
        <div
          onClick={close}
          tabIndex='0'
          class='JourneyDrawer-background'
          role='button'
          label='Close'
          onKeyDown={close}
        />
        <div class='JourneyDrawer-inner'>
          {children}
          <CloseButton onClose={close} />
        </div>
      </div>
    )
  }
}

JourneyDrawer.defaultProps = {
  open: false,
  children: null
}

JourneyDrawer.ANIMATION_DURATION = 400
